const policyTransition = {
    CREATE : 'create',

    GENERATE_BINDER : 'generate binder',

    MODIFY_BINDER : 'modify binder',

    BIND : 'bind',

    UNBIND : 'unbind',

    START_ISSUANCE : 'start issuance',

    MODIFY_ISSUANCE : 'modify issuance',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    REVERT_TO_BOUND : 'revert to bound',

    MARK_AS_ISSUED : 'mark as issued',

    REVERT_TO_DRAFT : 'revert to draft',

    REVERT_TO_PENDING_ISSUANCE : 'revert to pending issuance',

    REQUEST_CANCELLATION : 'request cancellation',

    SUBMIT_CANCELLATION : 'submit cancellation',

    RETRACT_CANCELLATION_REQUEST : 'retract cancellation request',

    RESCIND_CANCELLATION : 'rescind cancellation',

    MARK_AS_CANCELLED : 'mark as cancelled',

    REINSTATE : 'reinstate',

    REVERT_TO_CANCELLATION_PENDING : 'revert to cancellation pending',

    DELETE : 'delete',

    REPLACE : 'replace',

    ISSUE_REWRITE : 'issue rewrite',

    REISSUE : 'reissue',

    INITIATE_REWRITE : 'initiate rewrite',

    INITIATE_REISSUE : 'initiate reissue',

    REVERT_TO_CANCELLED : 'revert to cancelled',

    REWRITE : 'rewrite'

};

angular.module('gw-um-j2js')
    .constant('policyTransition', policyTransition);